import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ResetComponent} from './reset.component';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [ResetComponent],
  exports: [ResetComponent],
})
export class ResetModule {}



// WEBPACK FOOTER //
// ./src/app/auth/reset/reset.module.ts